var radioBtnData = {
  name: 'radioButton',
  data: [{
    fontFamily: '',
    fontSize: 12,
    fontColor: '#465476',
    radius: 2,
    btnHeight: 28,
    btnPadding: '0 8px',
    btnBoxShadow: 'none',
    borderColor: '#E8E8E8',
    checkedFontColor: '#0840F8',
    checkedBorderColor: '#0840F8',
    checkedBgColor: '#fff',
    disabledFontColor: '#A6ACBD',
    disabledBorderColor: '#E8E8E8',
    disabledBgColor: '#F9F9F9',
    checkedDisableBorderColor: '#D9E6F2',
    checkedDisableFontColor: '#5365EA',
    checkedDisableBgColor: '#F5F6FA',
    groupBorderRadius: 2,
    groupBorderRadiusOther: 0,
    verticalAligin: 'middle'
  }]
};
export default radioBtnData;